<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">营销</a></el-breadcrumb-item>
        <el-breadcrumb-item>分销设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">  
        <el-form-item > 
          <el-dropdown @command="handleCommand">
            <el-button type="primary">
            新增<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">商品</el-dropdown-item>
              <el-dropdown-item command="1">计次</el-dropdown-item>
              <el-dropdown-item command="2">买单</el-dropdown-item>
              <el-dropdown-item command="3">抢购</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>   
        </el-form-item>    
        <el-form-item >
          <el-input  placeholder="名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-tabs v-model="activeType" @tab-click="handleClick">
        <el-tab-pane label="商品" name="0"></el-tab-pane>
        <el-tab-pane label="计次" name="1"></el-tab-pane>
        <el-tab-pane label="买单" name="2"></el-tab-pane>
        <el-tab-pane label="抢购" name="3"></el-tab-pane>
      </el-tabs>
      <el-table :data="rows" style="width: 100%">
        <el-table-column  prop="Name"  label="名称"> </el-table-column>
        <el-table-column  prop="Type"  label="类型" :show-overflow-tooltip="true" > 
          <template slot-scope="scope">
            <p v-if="scope.row.Type==0">
              商品分销
            </p>
            <p v-if="scope.row.Type==1">
              计次分销
            </p>  
            <p v-if="scope.row.Type==2">
              买单分销
            </p>   
            <p v-if="scope.row.Type==3">
              抢购分销
            </p>    
          </template>
        </el-table-column>
        <el-table-column  prop="Reward"  label="奖励"> 
           <template slot-scope="scope">
            <p > {{scope.row.Reward}}% </p>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="editRow(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="DeleteRow(scope.row)" type="text" size="small">&nbsp;删除</el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>   
    <dia v-bind:dialog="dialog" ></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './info'
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        sort:' Id desc',
        type:0,
        rows:[],
        activeType:'',
        title:'',
        dialog: {
          title: '',
          isShow:false,
          type:0
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'Post',
          url:that.global.serverSrc + '/api/ShareSale/Index',
          data:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort,
            Type: that.activeType
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.totalPage = resp.data.totalPage
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      DeleteRow(row) {
        this.$confirm('确实要删除分销['+row.Name+']吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/ShareSale/Delete',
            data:{
              id: row.Id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      editRow:function(row){
        this.dialog.title = '编辑分销'
        this.dialog.type = row.Type
        this.dialog.id = row.Id
        this.dialog.isShow = true
      },
      handleClick:function(){
        this.Search()
      },
      handleCommand:function(command){
        this.dialog.title = '新增分销'
        this.dialog.type = command
        this.dialog.id = 0
        this.dialog.isShow = true
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    },
    components:{    
      dia
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>